export default "__VITE_ASSET__3d73a787__"